export default {
  width: 2048,
  height: 1536
};
